var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "magic-canvas-outer-container" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeStage.preview === true,
            expression: "activeStage.preview === true",
          },
        ],
        class: {
          "loading-image-breathing loading-image-greyscale":
            _vm.currentJob.state === "processing",
        },
      },
      [_c("canvas", { attrs: { id: "magic-canvas-preview" } })]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeStage.preview === false,
            expression: "activeStage.preview === false",
          },
        ],
      },
      [_c("canvas", { attrs: { id: "magic-canvas" } })]
    ),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { attrs: { id: "magic-canvas-export-container" } }, [
      _c("canvas", { attrs: { id: "magic-canvas-export" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }